import { useTranslation } from 'react-i18next'

/**
 * <b>Tamamlanma Notu</b> bloğu (105) — bilgi kartının <b>altında</b>, tam genişlikte.
 *
 * <p><b>Neden ızgarada değil</b> (kullanıcı kararı 2026-09-16, ekran görüntüsüyle): alan
 * {@code COMPLETION_NOTE} 2.000 karaktere kadar çıkabilir ve {@code mtg-info-grid} gözleri
 * ~220px'tir. Not önce ızgarada tam genişlik satırı olarak denendi (kartı ikiye bölüyordu), sonra
 * diğer alanların peşine alındı (dar gözde upuzun bir sütun oldu). Üçüncü ve kalıcı biçim:
 * <b>ızgaradan çıkarılıp</b> Açıklama bölümünün kalıbına konur.
 *
 * <p><b>Kırpma YOK.</b> İki satırda kesip gerisini yalnız hover'a bırakan biçim bu projede bir kez
 * denendi ve kullanıcı bunu <b>veri kaybı</b> olarak bildirdi (2026-08-14, hedef teslim tarihi
 * talepleri — gerekçe {@code deadlineRequests.css}'te duruyor). Aynı hataya ikinci kez düşülmez:
 * metin tam görünür, satır sonları korunur ve uzun bir dizi yatay kaydırma üretmez.
 *
 * <p>Not yoksa <b>hiçbir şey çizilmez</b> — boş bir başlık, hiç yaşanmamış bir olayı varmış gibi
 * gösterirdi ("Kapanma Tarihi" hücresiyle aynı kural).
 *
 * <p><b>Üç yüzey bunu paylaşır</b> ve ikisi ızgarayı da paylaşır ({@code ActionInfoGrid}): Görev
 * Detay, Alt Görev Detay ve "Ana Görevi Gör" pop-up'ı. Kopyalansaydı üç ekran zamanla ayrışırdı —
 * kullanıcı aynı kaydı üç yerde farklı görürdü.
 *
 * <p><b>Konum yüzeye aittir, bu bileşene değil:</b> blok kendi kartını çizer ({@code minutes-section})
 * ve nereye konacağını çağıran sayfa söyler. Alt Görev Detay'da 22.09.2026'da kullanıcı isteğiyle
 * görev kartının İÇİNDEN çıkarılıp <b>Dokümanlar'ın üstüne</b> alındı (kart içinde kart görünüyordu).
 */
export default function ActionCompletionNote({ note }: Readonly<{ note: string | null | undefined }>) {
  const { t } = useTranslation()
  if (!note) {
    return null
  }
  return (
    <section className="minutes-section">
      <div className="minutes-section-head">
        <h2>{t('actions.detail.info.completionNote')}</h2>
      </div>
      <p className="act-readonly-text">{note}</p>
    </section>
  )
}
